module.exports = __webpack_public_path__ + "img/search.23badc84.svg";